module.exports = __webpack_public_path__ + "img/data_not_found.ab588703.png";